import React from 'react';
import { useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

import { StyledToggleButton } from 'components/filters/FilterToggleInput';


const useStyles = makeStyles(t => ({
	root: {
		marginBottom: 4,
	},	
}));


export const IsSelectedViewToggleFilter = ({ 
	isSelectedViewMode: value, 
	setIsSelectedViewMode: onChange, 
	disabled
}) => {
	const classes = useStyles();
	const translate = useTranslate();

	const handleOnChange = () => {
		const newVal = !value;
		onChange(newVal);
	};

	return (
		<StyledToggleButton
			classes={classes}
			value={value}
			selected={value}
			onChange={handleOnChange}
			disabled={disabled}
		>
			{translate("osfc.filters.toggles.selected")}
		</StyledToggleButton>
	);
};
